import script from "./ProductCardSBL.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCardSBL.vue?vue&type=script&setup=true&lang=js"

import "./ProductCardSBL.vue?vue&type=style&index=0&id=746cdb2a&scoped=true&lang=css"
import "./ProductCardSBL.vue?vue&type=style&index=1&id=746cdb2a&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-746cdb2a"]])

export default __exports__